import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-10" }
const _hoisted_2 = { class: "feature-checkboxes col span-6" }
const _hoisted_3 = { class: "col span-6" }
const _hoisted_4 = { class: "row mb-10" }
const _hoisted_5 = { class: "col span-12" }
const _hoisted_6 = { class: "row mt-20 mb-10" }
const _hoisted_7 = { class: "col span-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_KeyValue = _resolveComponent("KeyValue")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Banner, {
      color: "info",
      "label-key": "gke.loggingService.infoBanner"
    }),
    _cache[12] || (_cache[12] = _createTextVNode()),
    (_ctx.showLoggingMonitoringBanner)
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 0,
          color: "warning",
          "label-key": "gke.loggingService.warningBanner"
        }))
      : _createCommentVNode("", true),
    _cache[13] || (_cache[13] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Checkbox, {
          value: _ctx.loggingEnabled,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loggingEnabled) = $event)),
          mode: _ctx.mode,
          "label-key": "gke.loggingService.label"
        }, null, 8, ["value", "mode"]),
        _cache[7] || (_cache[7] = _createTextVNode()),
        _createVNode(_component_Checkbox, {
          value: _ctx.monitoringEnabled,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.monitoringEnabled) = $event)),
          mode: _ctx.mode,
          "label-key": "gke.monitoringService.label"
        }, null, 8, ["value", "mode"]),
        _cache[8] || (_cache[8] = _createTextVNode()),
        _createVNode(_component_Checkbox, {
          value: _ctx.httpLoadBalancing,
          mode: _ctx.mode,
          "label-key": "gke.httpLoadBalancing.label",
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:httpLoadBalancing', $event)))
        }, null, 8, ["value", "mode"]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        _createVNode(_component_Checkbox, {
          value: _ctx.horizontalPodAutoscaling,
          mode: _ctx.mode,
          "label-key": "gke.horizontalPodAutoscaling.label",
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:horizontalPodAutoscaling', $event)))
        }, null, 8, ["value", "mode"]),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createVNode(_component_Checkbox, {
          value: _ctx.enableKubernetesAlpha,
          mode: _ctx.mode,
          "label-key": "gke.enableKubernetesAlpha.label",
          disabled: !_ctx.isNewOrUnprovisioned,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:enableKubernetesAlpha', $event)))
        }, null, 8, ["value", "mode", "disabled"])
      ]),
      _cache[11] || (_cache[11] = _createTextVNode()),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LabeledSelect, {
          mode: _ctx.mode,
          options: _ctx.maintenanceWindowOpts,
          "label-key": "gke.maintenanceWindow.label",
          value: _ctx.maintenanceWindow,
          onSelecting: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:maintenanceWindow', $event)))
        }, null, 8, ["mode", "options", "value"])
      ])
    ]),
    _cache[14] || (_cache[14] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.enableKubernetesAlpha)
          ? (_openBlock(), _createBlock(_component_Banner, {
              key: 0,
              color: "warning",
              "label-key": "gke.enableKubernetesAlpha.warning",
              icon: "icon-warning"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[15] || (_cache[15] = _createTextVNode()),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_KeyValue, {
          mode: _ctx.mode,
          value: _ctx.labels,
          "as-map": true,
          title: _ctx.t('gke.clusterLabels.label'),
          "add-label": _ctx.t('gke.clusterLabels.add'),
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:labels', $event)))
        }, {
          title: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.t('gke.clusterLabels.label')), 1)
          ]),
          _: 1
        }, 8, ["mode", "value", "title", "add-label"])
      ])
    ])
  ]))
}